import React, { useEffect } from 'react'
import axios from 'axios'
import { connect, withRouter, Button, Checkbox, UserThumbHorizontal, T } from 'components'
import { fetchUpgradeDetails, selectMembership, fetchUserProfile } from 'store/actions'
import { PAYMENT_ENGINE } from 'common/endpoints'

import UpgradeForm from './UpgradeForm'
import MembershipSelect from './MembershipSelect/MembershipSelect'
import Step from './Step/Step'
import StyledUpgrade, { UpgradeReason } from './StyledUpgrade'
import Advantages from './Advantages/Advantages'

const PAYMENT_URL = sessionStorage?.peFlow ? '/payment/api/submit' : PAYMENT_ENGINE

const UpgradeFormContentsOldNiches = ({
  memberships: { gold, vip },
  selected,
  selectMembership,
  profile,
  vipEnabled,
}) => {
  return (
    <>
      {!profile.gold && (
        <MembershipSelect
          memberships={gold}
          selected={selected.gold}
          vipEnabled={vipEnabled}
          selectMembership={selectMembership}
        />
      )}
      {!profile.vip && (
        <Checkbox
          size="medium"
          name="vip"
          value={!!selected.vip}
          onChange={() => selectMembership({ vip: selected.vip ? null : vip })}
          text={`Add VIP ADD-ON for only ${vip.price.currency} ${vip.price.value} per ${vip.price.period} `}
        />
      )}
      <div className="proceed">
        <Button type="submit" color="cta" size="large" label="payment/continue" />
      </div>
    </>
  )
}

const UpgradeFormContents = ({ memberships: { gold, vip }, selected, selectMembership, profile, vipEnabled, meta }) => {
  if (!vipEnabled) {
    return (
      <>
        <MembershipSelect
          memberships={gold}
          selected={selected.gold}
          selectMembership={selectMembership}
          className="no-vip"
        />
        <p className="call-center">
          <T label="payment/callCenter" /> <strong>{meta.contactPhoneNumber}</strong>
        </p>
        <T as="p" className="always-secure" label="payment/alwaysSecure" />
      </>
    )
  }
  return (
    <>
      {!profile.gold && (
        <Step index="1" title="Choose a plan">
          <MembershipSelect
            memberships={gold}
            selected={selected.gold}
            vipEnabled={vipEnabled}
            selectMembership={selectMembership}
          />
        </Step>
      )}
      {!profile.vip && (
        <Step index={!profile.gold ? '2' : '1'} title="Want a VIP pass?" className="step-vip">
          <Checkbox
            size="medium"
            name="vip"
            value={!!selected.vip}
            onChange={() => selectMembership({ vip: selected.vip ? null : vip })}
            text={`Add VIP ADD-ON for only ${vip.price.currency} ${vip.price.value} per ${vip.price.period} `}
          />
        </Step>
      )}
      <div className="proceed">
        <Button type="submit" color="cta" size="large" label="payment/continue" />
      </div>
    </>
  )
}

const loadPE = (window.loadPE = (settings = {}) => {
  settings.form = document.querySelector('.pe-form')
  settings.form.action = '/payment/api/submit'

  window.$?.DF?.Payment
    ? window.$.DF.Payment.load(settings)
    : axios.get('/scripts/df.payment.js').then(r => {
        new Function(r.data)()
        window.$.DF.Payment.load(settings)
      })
})

const Upgrade = ({ upgrade, query, profile, userProfile, vipEnabled, ...actions }) => {
  const { memberships, selected, meta, loaded } = upgrade
  const { fetchUpgradeDetails, fetchUserProfile, selectMembership } = actions

  const onSubmit = e => {
    const form = document.querySelector('.pe-form')
    if (form.action.includes('/api')) {
      e.preventDefault()
      loadPE({ form, mock: sessionStorage.peMock })
    }
  }

  useEffect(() => {
    fetchUpgradeDetails(query)

    if (query.referUser && userProfile.nickname !== query.referUser) {
      fetchUserProfile(query.referUser)
    }
  }, [])

  if (!loaded) {
    return null
  }

  return (
    <StyledUpgrade vipEnabled={vipEnabled}>
      <div>
        <UpgradeReason vipEnabled={vipEnabled}>
          {!!query.referUser && (
            <div className="user">
              <UserThumbHorizontal user={userProfile} />
            </div>
          )}
          <p className="description" dangerouslySetInnerHTML={{ __html: meta.reason }} />
        </UpgradeReason>
        {vipEnabled && <Advantages vipEnabled={vipEnabled} contactPhoneNumber={meta.contactPhoneNumber} />}
      </div>

      <UpgradeForm memberships={memberships} selected={selected} formProps={{ action: PAYMENT_URL, onSubmit }}>
        {vipEnabled ? (
          <UpgradeFormContentsOldNiches {...{ selected, memberships, profile, vipEnabled, selectMembership, meta }} />
        ) : (
          <UpgradeFormContents {...{ selected, memberships, profile, vipEnabled, selectMembership, meta }} />
        )}
      </UpgradeForm>
    </StyledUpgrade>
  )
}

const mapStateToProps = ({ router, upgrade, myProfile, userProfile, flags, siteConfig }) => ({
  query: router.location.query,
  upgrade,
  userProfile,
  profile: myProfile,
  vipEnabled: siteConfig.features.vipEnabled || flags.vip,
})

const ConnectedUpgrade = connect(mapStateToProps, { fetchUpgradeDetails, selectMembership, fetchUserProfile })(Upgrade)

export default withRouter(ConnectedUpgrade)
